import getRtcStatsReportAdapter from './get_rtc_stats_report_adapter';
import createRtcStatsReportParser from './createRtcStatsReportParser';

// This returns the array-ified list of stats our users are accustomed to
export default (peerConnection, track, completion) => {
  getRtcStatsReportAdapter(peerConnection, track, (err, rtcStatsReport) => {
    if (err) {
      completion(err);
      return;
    }
    completion(null, createRtcStatsReportParser()(rtcStatsReport));
  });
};
